import Common from "../../../Common";

const Reload = class extends Common {
	async async(companyId: id) {
		return this.post(`/company/${companyId}/pbx/reload/async`)
	}
}

export default Reload
